








import vue from "vue";
import { VUEX_EXERCISE_GETTER_NAMES, VUEX_EXERCISE_NAMESPACE } from "@tt-app/constants";

const { ANSWERS } = VUEX_EXERCISE_GETTER_NAMES;

interface Computed {
  derivedBody: any[];
  title: string | undefined;
  userInputBody: boolean;
}

interface Props {
  body: any[];
  elementIndex: number | undefined;
  problemUuid: string;
}

export default vue.extend<any, any, Computed, Props>({
  name: "ExercisePlainText",

  props: {
    body: {
      type: Array,
      default: undefined
    },
    elementIndex: {
      type: Number,
      default: undefined
    },
    problemUuid: {
      type: String,
      default: undefined
    }
  },

  computed: {
    derivedBody() {
      const answers = this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${ANSWERS}`];

      if (this.userInputBody) {
        return answers[this.problemUuid]?.split("\n");
      }

      return this.body;
    },

    title() {
      const writingQuestionTitle = this.$__("exercise.writing.header.question");
      const writingAnswerTitle = this.$__("exercise.writing.header.answer");

      switch (true) {
        case this.elementIndex === 0:
          return writingQuestionTitle;
        case this.userInputBody:
          return writingAnswerTitle;
        default:
          return undefined;
      }
    },

    userInputBody() {
      return this.body[0] === "USER_INPUT";
    }
  }
});
